import React from 'react'
import { ModuleParameter } from '~/models'
import { observer } from '~/ui/component'
import { HBox, NumberField, SwitchField, VBox } from '~/ui/components'
import { FormField, useForm } from '~/ui/form'
import { useResourceTranslation } from '~/ui/resources'
import { layout } from '~/ui/styling'
import ParameterFormModel from '../ParameterFormModel'

export interface Props {
  parameter: ModuleParameter
}

const NumberParameterFieldset = observer('NumberParameterFieldset', (props: Props) => {

  const {t}  = useResourceTranslation('modules')
  const {model: formModel} = useForm<ParameterFormModel>()

  //------
  // Rendering

  function render() {
    return (
      <VBox gap={layout.padding.s}>
        <HBox gap={layout.padding.s} align='top'>
          <VBox flex>
            <FormField name='min' {...t('parameters.fields.min')}>
              {bind => <NumberField {...bind} minimum={0} maximum={formModel.max} step={1}/>}
            </FormField>
          </VBox>
          <VBox flex>
            <FormField name='max' {...t('parameters.fields.max')}>
              {bind => <NumberField {...bind} minimum={formModel.min} step={1}/>}
            </FormField>
          </VBox>
        </HBox>
        <FormField name='integer' {...t('parameters.fields.integer')}>
          {bind => <SwitchField {...bind}/>}
        </FormField>
      </VBox>
    )
  }

  return render()

})

export default NumberParameterFieldset